import React from "react";

export default function MonitorIcon({ color }: { color: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke={color} className="w-3 tsm-400:w-4 h-3 tsm-400:h-4">
            <rect x="3" y="4" width="18" height="14" rx="2" />
            <path d="M8 20h8" />
            <path d="M9 10l-2 2 2 2M15 10l2 2-2 2" />
        </svg>
    );
}

